import { render, staticRenderFns } from "./importExportLoss.vue?vue&type=template&id=063d8e19&scoped=true&"
import script from "./importExportLoss.vue?vue&type=script&lang=js&"
export * from "./importExportLoss.vue?vue&type=script&lang=js&"
import style0 from "./importExportLoss.vue?vue&type=style&index=0&id=063d8e19&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063d8e19",
  null
  
)

export default component.exports